var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("default-item", {
    staticClass: "pancho_willies_drink_item--container",
    attrs: { item: _vm.item, "pricing-types": _vm.pricingTypes },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }